






































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import axios from 'axios';
import range from 'lodash-es/range';
import moment from 'moment';

@Component({
  components: {}
})
export default class MinerAdminView extends Vue {
  private emails = [];
  private emailsMetadata: any = {};
  private isLoading = false;
  private isEmailInfoModelOpen = false;
  private selectedEmail = null;
  private query = '';
  private currentPage = 1;
  private perPage = 20;
  private refresher?: number;
  private withHealthcheck: boolean = false;
  private maxPagesLimit: number = 15;

  @Watch('perPage')
  protected onChildChanged() {
    this.currentPage = 1;
    this.loadData().catch(console.error);
  }

  @Watch('withHealthcheck')
  protected onWithHealthcheckChanged() {
    this.loadData().catch(console.error);
  }

  get perPageDropdown() {
    return [20, 40, 60, 80, 100].map((val) => ({ value: val, text: val.toString() }));
  }

  get pages() {
    const pagesMax = this.emailsMetadata.totalPages + 1;
    return range(1, pagesMax > (this.maxPagesLimit + 1) ? (this.maxPagesLimit + 1) : pagesMax);
  }

  protected async created() {
    await this.loadData();
    this.refresher = setInterval(() => {
      this.loadData().catch(console.error);
    }, 1000);
  }

  protected beforeDestroy() {
    if (this.refresher) {
      clearInterval(this.refresher);
    }
  }

  protected viewEmailInfo(email) {
    this.selectedEmail = email;
    this.isEmailInfoModelOpen = true;
  }

  protected async reprocessEmail(email) {
    email.is_processing = true;
    try {
      await axios.post(`admin/miner/emails/${email._id}/reprocess`);
      this.$notify({ type: 'success',  text: 'The email will be re-processed shortly.' });
      await this.loadData();
    } catch (e) {
      switch (e.response.status) {
        case 410: {
          this.$notify({ type: 'warning',  text: 'This email is no longer available for re-processing.' });
          break;
        }
        case 409: {
          this.$notify({ type: 'warning',  text: 'Cannot re-process emails that are waiting for password.' });
          break;
        }
        default: {
          this.$notify({ type: 'error',  text: e.message });
        }
      }
    }
    email.is_processing = false;
  }

  protected gotoPage(page) {
    this.currentPage = page;
    return this.loadData();
  }

  private async loadData() {
    this.isLoading = true;
    try {
      const response = await axios.get('admin/miner/emails', {
        params: {
          query: this.query,
          per_page: this.perPage,
          page: this.currentPage,
          with_healthcheck: this.withHealthcheck,
        }
      });
      this.emails = response.data.items.map((email) => {
        email.is_processing = false;
        email.can_reprocess = false;
        if (email.incoming_email_metadata.receipt.Action.type === 'S3' && !email.incoming_email_metadata.reprocess) {
          email.can_reprocess = moment(email.incoming_email_metadata.mail.timestamp)
            .isAfter(moment.utc().subtract(1, 'day'));
        }
        return email;
      });
      this.emailsMetadata = response.data.meta;
      this.currentPage = this.emailsMetadata.current;
    } catch (e) {
      this.$notify({type: 'error', text: e.message});
    }
    this.isLoading = false;
  }
}
